import styles from "./AnnouncementBanner.module.scss";
import { ReactComponent as Xclose } from "../../assets/SVGs/x-close.svg";
import { ReactComponent as Arrows} from "../../assets/SVGs/double-chevron-right.svg";
import Button2 from "../Button2";
import SnapSection from "../SnapSection";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { getAnnounce } from "./helper";

const AnnouncementBanner = () => {
    const [list, setList] = useState({
        title: "",
        desc: "initial",
        urgent: false,
        buttonText: "",
        link: "",
    });
    const [showAnnouncement, setShowAnnouncement] = useState(() => {
        const savedState = localStorage.getItem("showAnnouncement");
        return savedState !== null ? JSON.parse(savedState) : true;
    });

    const [announcementID, setAnnouncementID] = useState(() => {
        const savedID = localStorage.getItem("announcementID");
        return savedID !== null ? JSON.parse(savedID) : list.desc;
    });

    useEffect(() => {
        handleResize();
        const getData = () => {
            axios
                .get(`${process.env.REACT_APP_API_URL}/user/faqs?type=announcement`)
                .then((res) => {
                    const cleanlist = getAnnounce(res.data.data);
                    setList(cleanlist);
                    //handleResize();
                    if (list.desc !== "initial" && list.desc !== announcementID) {
                        handleNewAnnouncement(list.desc);
                    }
                })
                .catch((err) => {
                    console.error("Error fetching data:", err);
                    toggleMenu(false);
                });
        };

        const handleNewAnnouncement = (newDesc) => {
            toggleMenu(true);
            setAnnouncementID(newDesc);
            localStorage.setItem("announcementID", JSON.stringify(newDesc));
        };
        window.addEventListener("resize", handleResize);
        getData();
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [list.desc, announcementID]);

    const handleResize = () => {
        const nav = document.getElementById("bBAnnouncementBanner");
        const header = document.getElementById("bBNavHeader");
        const height = nav ? nav.offsetHeight : 0;
        header.style.setProperty("padding-top", `${height}px`);
    };

    const toggleMenu = (override) => {
        setShowAnnouncement(override);
        const nav = document.getElementById("bBAnnouncementBanner");
        const header = document.getElementById("bBNavHeader");
        const height = nav ? nav.offsetHeight : 0;
        if (override === false) {
            header.style.setProperty("padding-top", `0px`);
        } else {
            header.style.setProperty("padding-top", `${height}px`);
        }
        localStorage.setItem("showAnnouncement", JSON.stringify(override));
    };

    return (
        <>
        <SnapSection 
                id="bBAnnouncementBanner"
                className={`${styles.announce} ${list.urgent === 'true' && styles.urgent}`} 
                short>
            {showAnnouncement && list.desc && list.desc !== "initial" ? (
                    <div className={styles.announcementBanner}>
                        <div className={styles.content}>
                            <p className={styles.navMobileMenuText}>
                                <span 
                                style={{ display: !list.title && "none"}} 
                                className={styles.title}>
                                    {list.title}&nbsp;&nbsp;&nbsp;
                                </span>
                                {list.desc}
                            </p>
                            <Button2
                                className={styles.actionButton}
                                black={list.urgent === 'true' ? true : false}
                                light={list.urgent === 'false' ? true : false}
                                sm
                                linkButton
                                style={{ display: list.link ? "flex": "none"}}
                                href={list.link || "#"}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <p>{list.buttonText || "Read More"}</p> <Arrows />
                            </Button2>
                        </div>
                        <button
                            aria-label="Dismiss announcement"
                            className={styles.closeButton}
                            onClick={() => toggleMenu(false)}
                        >
                            <Xclose />
                        </button>
                    </div>
                
            ): (<></>)}
            </SnapSection>
        </>
    );
};

export default AnnouncementBanner;